import React from "react";

/*
  Custom implementation of ErrorBoundary,
  since this mechanism works in React >= 16.
  Currently 15 is used.
 */
class ErrorBoundary extends React.Component {
  componentDidMount() {
    window.addEventListener("error", this._handleError)
  }

  componentWillUnmount() {
    window.removeEventListener("error", this._handleError)
  }

  _handleError(error) {
    window.Sentry.withScope(() => {
      if (error.error) {
        window.Sentry.captureException(error.error.stack)
      } else {
        window.Sentry.captureException(error.message)
      }

      window.Sentry.setTag("url", error.currentTarget.isomorphicVars.public_url)
    })
  }

  render() {
    return this.props.children
  }
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./webapp/components/ErrorBoundary.js